import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_217e657c from 'nuxt_plugin_plugin_217e657c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_7c032ff2 from 'nuxt_plugin_plugin_7c032ff2' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_googleanalytics_1e117e54 from 'nuxt_plugin_googleanalytics_1e117e54' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_a0d3b38c from 'nuxt_plugin_cookieuniversalnuxt_a0d3b38c' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_portalvue_2038cd01 from 'nuxt_plugin_portalvue_2038cd01' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_image_5dd6e78d from 'nuxt_plugin_image_5dd6e78d' // Source: ./image.js (mode: 'all')
import nuxt_plugin_toast_3f003741 from 'nuxt_plugin_toast_3f003741' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_72cfea92 from 'nuxt_plugin_axios_72cfea92' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_srcplugin1765b690_6b686bf2 from 'nuxt_plugin_srcplugin1765b690_6b686bf2' // Source: ./src.plugin.1765b690.js (mode: 'client')
import nuxt_plugin_workbox_ff5ff9a4 from 'nuxt_plugin_workbox_ff5ff9a4' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_63423c41 from 'nuxt_plugin_metaplugin_63423c41' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_67e9e1b5 from 'nuxt_plugin_iconplugin_67e9e1b5' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_moment_144e0d74 from 'nuxt_plugin_moment_144e0d74' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_sweetalert_2b24bc6a from 'nuxt_plugin_sweetalert_2b24bc6a' // Source: ../plugins/sweet-alert (mode: 'all')
import nuxt_plugin_i18n_926bd3dc from 'nuxt_plugin_i18n_926bd3dc' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_localenumb_8f1cae9c from 'nuxt_plugin_localenumb_8f1cae9c' // Source: ../plugins/i18n/locale-numb (mode: 'all')
import nuxt_plugin_common_25e198df from 'nuxt_plugin_common_25e198df' // Source: ../plugins/common (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_vuechartkick_75088629 from 'nuxt_plugin_vuechartkick_75088629' // Source: ../plugins/vue-chartkick (mode: 'all')
import nuxt_plugin_aos_254294c8 from 'nuxt_plugin_aos_254294c8' // Source: ../plugins/aos.client (mode: 'client')
import nuxt_plugin_lottie_52d78ad6 from 'nuxt_plugin_lottie_52d78ad6' // Source: ../plugins/lottie (mode: 'client')
import nuxt_plugin_videoembed_503c6e86 from 'nuxt_plugin_videoembed_503c6e86' // Source: ../plugins/video-embed.js (mode: 'client')
import nuxt_plugin_vueloading_3cae3250 from 'nuxt_plugin_vueloading_3cae3250' // Source: ../plugins/vue-loading.js (mode: 'client')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'client')
import nuxt_plugin_notifications_36de4932 from 'nuxt_plugin_notifications_36de4932' // Source: ../plugins/notifications (mode: 'client')
import nuxt_plugin_swiper_3a1c5924 from 'nuxt_plugin_swiper_3a1c5924' // Source: ../plugins/swiper (mode: 'client')
import nuxt_plugin_vuequilleditor_67e94cdc from 'nuxt_plugin_vuequilleditor_67e94cdc' // Source: ../plugins/vue-quill-editor (mode: 'client')
import nuxt_plugin_formrule_09aac2f1 from 'nuxt_plugin_formrule_09aac2f1' // Source: ../plugins/form-rule (mode: 'all')
import nuxt_plugin_vmask_42ab70d7 from 'nuxt_plugin_vmask_42ab70d7' // Source: ../plugins/v-mask (mode: 'all')
import nuxt_plugin_vuecarousel_eb857b48 from 'nuxt_plugin_vuecarousel_eb857b48' // Source: ../plugins/vue-carousel.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"Startup Cambodia - %s","htmlAttrs":{"lang":"en"},"title":"startup_cambodia","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Startup Cambodia is the National Program lead by the Ministry of Economy and Finance with a mission to support local startups and build a vibrant entrepreneurship ecosystem in Cambodia."},{"hid":"image","name":"image","content":"\u002Fimages\u002Fstartup-cambodia.png"},{"hid":"og:title","name":"og:title","content":"Startup Cambodia"},{"hid":"og:description","name":"og:description","content":"Startup Cambodia is the National Program lead by the Ministry of Economy and Finance with a mission to support local startups and build a vibrant entrepreneurship ecosystem in Cambodia."},{"hid":"og:image","name":"og:image","content":"\u002Fimages\u002Fstartup-cambodia.png"},{"hid":"og:url","name":"og:url","content":"https:\u002F\u002Fstartupcambodia.gov.kh"},{"hid":"og:site_name","name":"og:site_name","content":"Startup Cambodia"},{"hid":"twitter:image","name":"twitter:image","content":"\u002Fimages\u002Fstartup-cambodia.png"},{"hid":"twitter:image:alt","name":"twitter:image:alt","content":"Startup Cambodia"},{"hid":"twitter:title","property":"twitter:title","content":"Startup Cambodia"},{"hid":"twitter:description","property":"twitter:description","content":"Startup Cambodia is the National Program lead by the Ministry of Economy and Finance with a mission to support local startups and build a vibrant entrepreneurship ecosystem in Cambodia."},{"hid":"twitter:card","property":"twitter:card","content":"summary_large_image"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","sizes":"16x16","href":"https:\u002F\u002Fmedia.startupcambodia.gov.kh\u002Fplatform\u002Fpublic-assets\u002Fsc-fav-icon.svg"},{"hid":"og:title","name":"og:title","content":"Startup Cambodia"},{"hid":"og:image","name":"og:image","content":"https:\u002F\u002Fmedia.startupcambodia.gov.kh\u002Fplatform\u002Fpublic-assets\u002Fsc-fav-icon.svg"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"script":[{"src":"https:\u002F\u002Fconnect.facebook.net\u002Fen_US\u002Fsdk.js#xfbml=1&version=v3.2"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_217e657c === 'function') {
    await nuxt_plugin_plugin_217e657c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_7c032ff2 === 'function') {
    await nuxt_plugin_plugin_7c032ff2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_1e117e54 === 'function') {
    await nuxt_plugin_googleanalytics_1e117e54(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_a0d3b38c === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_a0d3b38c(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_2038cd01 === 'function') {
    await nuxt_plugin_portalvue_2038cd01(app.context, inject)
  }

  if (typeof nuxt_plugin_image_5dd6e78d === 'function') {
    await nuxt_plugin_image_5dd6e78d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_3f003741 === 'function') {
    await nuxt_plugin_toast_3f003741(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_72cfea92 === 'function') {
    await nuxt_plugin_axios_72cfea92(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_srcplugin1765b690_6b686bf2 === 'function') {
    await nuxt_plugin_srcplugin1765b690_6b686bf2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_ff5ff9a4 === 'function') {
    await nuxt_plugin_workbox_ff5ff9a4(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_63423c41 === 'function') {
    await nuxt_plugin_metaplugin_63423c41(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_67e9e1b5 === 'function') {
    await nuxt_plugin_iconplugin_67e9e1b5(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_144e0d74 === 'function') {
    await nuxt_plugin_moment_144e0d74(app.context, inject)
  }

  if (typeof nuxt_plugin_sweetalert_2b24bc6a === 'function') {
    await nuxt_plugin_sweetalert_2b24bc6a(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_926bd3dc === 'function') {
    await nuxt_plugin_i18n_926bd3dc(app.context, inject)
  }

  if (typeof nuxt_plugin_localenumb_8f1cae9c === 'function') {
    await nuxt_plugin_localenumb_8f1cae9c(app.context, inject)
  }

  if (typeof nuxt_plugin_common_25e198df === 'function') {
    await nuxt_plugin_common_25e198df(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_vuechartkick_75088629 === 'function') {
    await nuxt_plugin_vuechartkick_75088629(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aos_254294c8 === 'function') {
    await nuxt_plugin_aos_254294c8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lottie_52d78ad6 === 'function') {
    await nuxt_plugin_lottie_52d78ad6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_videoembed_503c6e86 === 'function') {
    await nuxt_plugin_videoembed_503c6e86(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueloading_3cae3250 === 'function') {
    await nuxt_plugin_vueloading_3cae3250(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_notifications_36de4932 === 'function') {
    await nuxt_plugin_notifications_36de4932(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_3a1c5924 === 'function') {
    await nuxt_plugin_swiper_3a1c5924(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuequilleditor_67e94cdc === 'function') {
    await nuxt_plugin_vuequilleditor_67e94cdc(app.context, inject)
  }

  if (typeof nuxt_plugin_formrule_09aac2f1 === 'function') {
    await nuxt_plugin_formrule_09aac2f1(app.context, inject)
  }

  if (typeof nuxt_plugin_vmask_42ab70d7 === 'function') {
    await nuxt_plugin_vmask_42ab70d7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecarousel_eb857b48 === 'function') {
    await nuxt_plugin_vuecarousel_eb857b48(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
